/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import {
  createContent,
  createOpenInteractive,
  editContent,
  titleCheck,
  updateOpenInteractive,
} from '../../../middleware/api';
import { ButtonInterface } from '../../../redux/button/button';
import { IParentMessageData } from '../../../redux/parentDataSlice';
import store from '../../../redux/store';
import { validateButtonForm, validateChecklistForm } from '../validate';

export const getButtonStyle = (customisations: any, type: string) => {
  return {
    background: type === 'unhover' ? 'white' : `${customisations.bgColor}`,
    fontFamily: `${customisations.fontFamily}`,
    fontSize: `${customisations.fontSize}px`,
    fontStyle: `${customisations.fontStyle}`,
    color: type === 'unhover' ? `${customisations.bgColor}` : `${customisations.fontColor}`,
    border: `2px solid ${customisations.bgColor}`,
    paddingTop:
      customisations.customPaddingtop === '' ? 10 : `${customisations.customPaddingtop}px`,
    paddingLeft:
      customisations.customPaddingleft === '' ? 10 : `${customisations.customPaddingleft}px`,
    paddingBottom:
      customisations.customPaddingbottom === '' ? 10 : `${customisations.customPaddingbottom}px`,
    paddingRight:
      customisations.customPaddingright === '' ? 10 : `${customisations.customPaddingright}px`,
  };
};
export const handleButtonSubmit = async (
  props: any,
  isGlobal: boolean,
  config: any,
  dataFromParent: IParentMessageData,
  type: string,
  isCollaborative: boolean,
  id?: string,
) => {
  const { SetButtonFormError } = props;
  const buttonStateCollection = store.getState().button;
  let fail: any = {};
  if (type === 'Button') {
    fail = validateButtonForm(buttonStateCollection, SetButtonFormError);
    if (fail.title || fail.name || fail.link) return;
  } else if (type === 'checklist') {
    fail = validateChecklistForm(buttonStateCollection, SetButtonFormError);
    if (Object.keys(fail).length > 0) return;
  }

  const response = !id
    ? await createButtonInteractive(
        buttonStateCollection,
        config,
        isGlobal,
        dataFromParent,
        type,
        isCollaborative,
      )
    : await updateButtonInteractive(
        buttonStateCollection,
        config,
        isGlobal,
        id,
        dataFromParent,
        type,
        isCollaborative,
      );
  if (response?.error?.includes('already exist')) {
    SetButtonFormError({
      errors: { title: 'Title already exist, Please enter a new title' },
    });
    return;
  }
  return response;
};

export const collaborativePayload = ({
  title,
  type,
  libraryId,
  parameters,
  customisations,
  dataFromParent,
}: any) => {
  const { userId, orgId, courseId, pageId } = dataFromParent;

  return {
    course_id: courseId,
    page_id: pageId,
    interactive_title: title,
    organization_id: orgId,
    created_by: userId,
    platform_id: dataFromParent.ltiPlatformId,
    jsonContent: {
      library_id: libraryId,
      type,
      parameters,
      customisations,
    },
  };
};

const createInteractive = async (
  data: any,
  collabData: any,
  isCollaborative: boolean,
  collabType: string,
) => {
  switch (true) {
    case isCollaborative && collabType === 'page':
      return await createOpenInteractive(collabData, 'paginated-lint');
    case isCollaborative && collabType === 'template':
      return await createOpenInteractive(collabData, 'templated-lint');
    default:
      return await createContent(data);
  }
};

const updateInteractive = async (
  data: any,
  collabData: any,
  isCollaborative: boolean,
  collabType: string,
) => {
  switch (true) {
    case isCollaborative && collabType === 'page':
      return await updateOpenInteractive(collabData, 'paginated-lint');
    case isCollaborative && collabType === 'template':
      return await updateOpenInteractive(collabData, 'templated-lint');
    default:
      return await editContent(data);
  }
};

export const createButtonInteractive = async (
  props: ButtonInterface,
  config: any,
  isGlobal: boolean,
  dataFromParent: IParentMessageData,
  typeDate: string,
  isCollaborative: boolean,
) => {
  const { userId, orgId } = dataFromParent;
  const isChecklist = typeDate === 'checklist';
  const payload = isChecklist
    ? getChecklistDataStructure(props, isGlobal, config, userId, orgId)
    : getButtonDataStructure(props, isGlobal, config, userId, orgId);
  const apiData = JSON.parse(JSON.stringify(payload));
  const data = collaborativePayload({
    title: apiData.title,
    type: typeDate,
    libraryId: apiData.library_id,
    parameters: apiData.parameters,
    customisations: apiData.customisations,
    dataFromParent,
  });
  const response = await createInteractive(
    apiData,
    data,
    isCollaborative,
    dataFromParent.collabType ?? '',
  );
  return response;
};

export const updateButtonInteractive = async (
  props: ButtonInterface,
  config: any,
  isGlobal: boolean,
  id: string,
  dataFromParent: IParentMessageData,
  typeDate: string,
  isCollaborative: boolean,
) => {
  const { userId, orgId } = dataFromParent;
  const isChecklist = typeDate === 'checklist';
  const payload = isChecklist
    ? getChecklistDataStructure(props, isGlobal, config, userId, orgId)
    : getButtonDataStructure(props, isGlobal, config, userId, orgId);
  const parsedPayload = JSON.parse(JSON.stringify(payload));
  const apiData = {
    id,
    body: parsedPayload,
  };

  const data = {
    id,
    body: {
      ...collaborativePayload({
        title: parsedPayload.title,
        type: typeDate,
        libraryId: parsedPayload.library_id,
        parameters: parsedPayload.parameters,
        customisations: parsedPayload.customisations,
        dataFromParent,
      }),
      updated_by: userId,
    },
  };
  const response = updateInteractive(
    apiData,
    data,
    isCollaborative,
    dataFromParent.collabType ?? '',
  );
  return response;
};

export const checkInteractiveTitle = async (data: { title: string; organization_id: string }) => {
  const response = await titleCheck(data);
  if (response.error === null) {
    return true;
  }
  return false;
};

export const getButtonDataStructure = (
  props: ButtonInterface,
  isGlobal: boolean,
  config: any,
  userId: string,
  orgId: string,
) => {
  const { name, link, isChecked, title } = props;
  return {
    user_id: userId,
    library_id: 3,
    organization_id: orgId,
    title: title,
    parameters: {
      name,
      link,
      isChecked,
    },
    customisations: {
      bgColor: props.color,
      btnType: props.btnType,
      fontFamily: props.fontFamily,
      fontStyle: props.fontStyle,
      fontSize: props.fontSize,
      fontColor: props.fontColor,
      alignment: props.alignment,
      customPaddingtop: props.customPaddingtop !== '' ? props.customPaddingtop : '0',
      customPaddingleft: props.customPaddingleft !== '' ? props.customPaddingleft : '0',
      customPaddingbottom: props.customPaddingbottom !== '' ? props.customPaddingbottom : '0',
      customPaddingright: props.customPaddingright !== '' ? props.customPaddingright : '0',
      fontsList: JSON.stringify(config.fontFamilyList.fonts),
    },
    active: true,
    private: !isGlobal,
    global: isGlobal,
    editable: isGlobal,
  };
};

export const getChecklistDataStructure = (
  state: ButtonInterface,
  isGlobal: boolean,
  config: any,
  userId: string,
  orgId: string,
) => {
  return {
    user_id: userId,
    library_id: 10,
    organization_id: orgId,
    type: 'checklist',
    title: state.title,
    parameters: {
      name: state.name,
      checklistItems: state.checklistItems.map((item) => ({
        id: item.id,
        label: item.label,
        checked: item.checked,
      })),
    },
    customisations: {
      bgColor: state.color,
      btnType: state.btnType,
      fontFamily: state.fontFamily,
      fontStyle: state.fontStyle,
      fontSize: state.fontSize,
      fontColor: state.fontColor,
      alignment: state.alignment,
      customPaddingtop: state.customPaddingtop || '0',
      customPaddingleft: state.customPaddingleft || '0',
      customPaddingbottom: state.customPaddingbottom || '0',
      customPaddingright: state.customPaddingright || '0',
      fontsList: JSON.stringify(config.fontFamilyList.fonts),
      checkBoxColor: state.checkBoxColor,
      headerFontColor: state.headerFontColor,
      bodyFontFamily: state.bodyFontFamily,
      checklistBodyFontSize: state.checklistBodyFontSize,
      checklistBodyFontStyle: state.checklistBodyFontStyle,
      ChecklistBodyFontColor: state.ChecklistBodyFontColor,
      checklistBodyAlignment: state.checklistBodyAlignment,
      checklistBodyFontWeight: state.checklistBodyFontWeight,
      borderStyle: state.borderStyle,
      borderColor: state.borderColor,
      borderTop: state.borderTop || '0',
      borderBottom: state.borderBottom || '0',
      borderLeft: state.borderLeft || '0',
      borderRight: state.borderRight || '0',
      borderRadius: state.borderRadius || '0',
      ChecklistBgColor: state.ChecklistBgColor,
      strike: state.strike,
      fontWeightForHeader: state.fontWeightForHeader,
    },
    active: true,
    private: !isGlobal,
    global: isGlobal,
    editable: isGlobal,
  };
};
